import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";

export const getOrganizationListApiCall = createAsyncThunk("organizationList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: organizationList } = await API.getOrganizationListApi(submitData);
        dispatch(setLoader(false))
        return organizationList;
    } catch (error) {
        throw error;
    }
});

export const editOrganizationDataApiCall = createAsyncThunk("editOrganizationData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: editOrganizationData, code, message } = await API.editOrganizationDetailsApi(submitData);
        if (code === '1') {
            TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editOrganizationData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    organizationList: {
        data: [],
        error: null,
    },
    editOrganizationData: {
        data: null,
        code: '',
        message: '',
        error: null,
    }
};

const organizationSlice = createSlice({
    name: "ORGANIZATION",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getOrganizationListApiCall.fulfilled, (state, action) => {
                state.organizationList.data = action.payload;
            })
            .addCase(getOrganizationListApiCall.rejected, (state, action) => {
                state.organizationList.error = action.error.message;
            })
            .addCase(editOrganizationDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editOrganizationData.data = data;
                state.editOrganizationData.message = message;
                state.editOrganizationData.code = code;
            })
            .addCase(editOrganizationDataApiCall.rejected, (state, action) => {
                state.editOrganizationData.error = action.error.message;
            });
    },
});

export default organizationSlice.reducer;